<div class="svg-wrapper" [ngClass]="[size, bgColor, buttonBorder]">
  <div
    *ngIf="initials; else svgIcon"
    class="svg-wrapper__initials"
    [ngClass]="[iconColor]"
    [attr.data-e2e]="e2e ? e2e + '-initials' : undefined"
  >
    {{ this.initials }}
  </div>

  <ng-template #svgIcon>
    <app-svg-icon
      [fill]="iconColor"
      [icon]="iconName"
      [size]="iconSize"
      [e2e]="e2e ? e2e : undefined"
    ></app-svg-icon>
  </ng-template>
</div>
